module.exports = __webpack_public_path__ + "img/02.0b679f6b.png";